import React from 'react'

type Props = {
  title: string
  disabled?: boolean
}
const PostGraduationTab: React.FC<Props> = ({ children }) => {
  return <>{children}</>
}

export default PostGraduationTab
